// material-ui
import { Grid, Typography, Stack, Link } from '@mui/material';

// project imports
import MainCard from 'components/cards/MainCard';
import Main from 'views/layouts/Main/Main'; //
import {
	SimUnorderedList,
	SimSection,
	SimContactSupport,
	SimSectionHeader,
	StaticSectionWrapper
} from 'components/StaticSections';

const PrivacyPolicy = () => {
	return (
		<Main>
			<StaticSectionWrapper>
				<Grid container justifyContent='center' spacing={1}>
					<SimSectionHeader title='Privacy Policy' />
					<Grid item xs={12}>
						<MainCard elevation={4} border={false} boxShadow shadow={4} sx={{ mb: 3 }}>
							<Stack spacing={2} sx={{ textAlign: 'left' }}>
								<SimSection>
									<Typography textAlign={'justify'}>
										SIM SOULS GROUP LLC and SIM SOULS INSTITUTE 1 INC (the "Company", “SimSouls”,
										"we", "us" or "our") respect your privacy and are committed to protecting it
										through our compliance with this privacy policy ("Policy"). This Policy
										describes the types of information we may collect from you or that you may
										provide when you visit{' '}
										<Link href='www.simsouls.com' underline='none' sx={{ py: 1 }}>
											www.simsouls.com
										</Link>{' '}
										or use any of our applications and any mobile or web applications that we may
										provide (collectively, the "Website") and our practices for collecting, using,
										maintaining, protecting and disclosing that information.
									</Typography>
									<SimUnorderedList
										title='This Policy applies to information we collect:'
										list={[
											'On the Website.',
											'In e-mail, text, WhatsApp and other electronic messages between you and this Website.',
											'Through mobile and web applications you download from the Website or an application marketplace.'
										]}
									/>
									<SimUnorderedList
										title='It does not apply to information collected by:'
										list={[
											'us offline or through any other means, including on any other website operated by Company or any third party; or',
											'any third party, including through any application or content (including advertising) that may link to or be accessible from the Website.'
										]}
									/>
									<Typography textAlign={'justify'}>
										Please read this Policy carefully to understand our policies and practices
										regarding your information and how we will treat it. If you do not agree with
										our policies and practices, your choice is not to use our Website. By accessing
										or using our Website, you agree to this Policy. This Policy may change from time
										to time. Your continued use of the Website after we make changes is deemed to be
										acceptance of those changes, so please check the Policy periodically for
										updates.
									</Typography>
								</SimSection>

								<SimSection title='I. HOW WE USE YOUR INFORMATION'>
									<SimUnorderedList
										title='We use information that we collect about you or that you provide to us, including any personal information:'
										list={[
											'To present our Website and its contents to you.',
											'To provide you with information, products, or services that you request from us.',
											'To fulfill any other purpose for which you provide it.',
											'To notify you about changes to our Website or any products or services we offer or provide though it.',
											'In any other way we may describe when you provide the information.',
											'For any other purpose with your consent.'
										]}
									/>
									<Typography textAlign={'justify'}>
										We may also use your information to contact you about our goods and services
										that may be of interest to you.
									</Typography>
									<SimSection title='A. SERVING YOU'>
										<Typography textAlign={'justify'}>
											Our Website uses your personal information primarily for the purposes of
											providing our services to you in accordance with any request you make of us
											through the Website. The most common use of such personal information is to
											contact you in response to your request for information or provide job
											search services as identified above.
										</Typography>
									</SimSection>
									<SimSection title='B. MOBILE ALERTS'>
										<Typography textAlign={'justify'}>
											SimSouls can send you alerts to any mobile device you choose and designate
											through our Website (“Mobile Alerts”). Mobile Alerts include time-sensitive
											information, such as weather-related closings or news about other
											operational issues which might impact on our services to you.
										</Typography>
									</SimSection>
									<SimSection title='C. CUSTOMER SERVICE, SALES, AND MARKETING'>
										<Typography textAlign={'justify'}>
											Our sales or customer service team may also use your personal information in
											order to ensure your satisfaction with the Website or to answer any
											questions you might have. We may also compliment your information with
											commercially or publicly available information for the purposes of better
											serving you and marketing our goods and services to you through email or
											telephone calls. Should you choose not to receive such marketing, you can
											unsubscribe or opt out by following the instructions in any such
											communication.
										</Typography>
									</SimSection>
									<SimSection title='D. SHARING.'>
										<Typography textAlign={'justify'}>
											We do not sell or rent your personal information. We do not share your
											information with third parties for the purposes of marketing or selling
											third party products, or our own. We may share information with trusted
											third parties solely for the purpose of fulfilling any requests you make
											through our Website or improving the functionality of our Website. When
											required by law, the Company may disclose personally identifiable
											information as may be required by subpoena, search warrant, or other legal
											process.
										</Typography>
									</SimSection>
								</SimSection>

								<SimSection title='II. INFORMATION WE COLLECT ABOUT YOU AND HOW WE COLLECT IT'>
									<SimUnorderedList
										title='We collect several types of information from and about users of our Website, including information:'
										list={[
											'by which you may be personally identified, such as name, postal address, e-mail address, telephone number, geo-location and health information ("personal information");',
											'that is about you, but individually does not identify you, such as purchasing history; and/or',
											'about your internet connection, the equipment you use to access our Website and usage details.'
										]}
									/>
									<SimUnorderedList
										title='We collect this information:'
										list={[
											'Directly from you when you provide it to us.',
											'Automatically as you navigate through the site. Information collected automatically may include usage details, IP addresses and information collected through cookies and other tracking technologies.'
										]}
									/>
									<SimSection title='A. INFORMATION YOU PROVIDE US'>
										<SimUnorderedList
											title='The information we collect on or through our Website may include:'
											list={[
												'Information that you provide by filling in forms on our Website.',
												'Records and copies of your correspondence (including e-mail addresses), if you contact us.',
												'Your responses to surveys that we might ask you to complete for research purposes.',
												'Details of transactions you carry out through our Website and of the fulfillment of your orders.'
											]}
										/>
										<Typography textAlign={'justify'}>
											You also may provide information to be published or displayed (hereinafter,
											"posted") on public areas of the Website, or transmitted to other users of
											the Website or third parties (collectively, "User Contributions"). Your User
											Contributions are posted on and transmitted to others at your own risk.
											Additionally, we cannot control the actions of other users of the Website
											with whom you may choose to share your User Contributions. Therefore, we
											cannot and do not guarantee that your User Contributions will not be viewed
											by unauthorized persons.
										</Typography>
									</SimSection>
									<SimSection title='B. INFORMATION WE COLLECT THROUGH AUTOMATIC DATA COLLECTION TECHNOLOGIES'>
										<SimUnorderedList
											title='As you navigate through and interact with our Website, we may use automatic data collection technologies to collect certain information about your equipment, browsing actions and patterns, including:'
											list={[
												'Details of your visits to our Website, including traffic data, location data, logs and other communication data and the resources that you access and use on the Website.',
												'Information about your computer and internet connection, including your IP address, operating system, and browser type.'
											]}
										/>
										<SimUnorderedList
											title='The information we collect automatically helps us to improve our Website and to deliver a better and more personalized service, including by enabling us to:'
											list={[
												'Estimate our audience size and usage patterns.',
												'Store information about your preferences, allowing us to customize our Website according to your individual interests.',
												'Recognize you when you return to our Website.'
											]}
										/>
										<SimUnorderedList
											title='The technologies we use for this automatic data collection may include:'
											list={[
												'Cookies (or browser cookies). A cookie is a small file placed on the hard drive of your computer. You may refuse to accept browser cookies by activating the appropriate setting on your browser. However, if you select this setting, you will be unable to effectively use the services of our Website. Unless you have adjusted your browser setting so that it will refuse cookies, our system will issue cookies when you direct your browser to our Website.',
												'Web Beacons. Pages of our Website may contain small electronic files known as web beacons (also referred to as clear gifs. pixel tags and single-pixel gifs) that permit the Company, for example, to count users who have visited those pages or and for other related website statistics (for example, recording the popularity of certain website content and verifying system and server integrity).'
											]}
										/>
										<Typography textAlign={'justify'}>
											We do not collect personal information automatically, but we may tie this
											information to personal information about you that we collect from other
											sources, or you provide to us.
										</Typography>
									</SimSection>
								</SimSection>

								<SimSection title='III. DISCLOSURE OF YOUR INFORMATION'>
									<SimUnorderedList
										title='We may disclose aggregated information about our users, and information that does not identify any individual, without restriction. We may disclose personal information that we collect, or you provide as described in this Policy:'
										list={[
											'To contractors, service providers and other third parties we use to support our business.',
											"To a buyer or other successor in the event of a merger, divestiture, restructuring, reorganization, dissolution or other sale or transfer of some or all SimSouls's assets, whether as a going concern or as part of bankruptcy, liquidation, or similar proceeding, in which personal information held by SimSouls about our Website users is among the assets transferred.",
											'To fulfill the purpose for which you provide it.',
											'For any other purpose disclosed by us when you provide the information.',
											'With your consent.'
										]}
									/>
									<SimUnorderedList
										title='We may also disclose your personal information:'
										list={[
											'To comply with any court order, law, or legal process, including responding to any government or regulatory request.',
											'To enforce or apply our terms of use and other agreements, including for billing and collection purposes.',
											'If we believe disclosure is necessary or appropriate to protect the rights, property, or safety of SIMSOULS, our customers or others.'
										]}
									/>
									<Typography>Choices About How We Use and Disclose Your Information</Typography>
									<SimUnorderedList
										title='We strive to provide you with choices regarding the personal information you provide to us. We have created mechanisms to provide you with the following control over your information:'
										list={[
											'Tracking Technologies. You can set your browser to refuse all or some browser cookies, or to alert you when cookies are being sent. If you are unable to or refuse cookies, please note that the service as provided on our Website will not function properly.'
										]}
									/>
								</SimSection>

								<SimSection title='IV. ACCESSING AND CORRECTING YOUR INFORMATION'>
									<Typography textAlign={'justify'}>
										You can review and change your personal information by logging into the Website
										and visiting your account profile page. You may also send us an e-mail at{' '}
										<Link href='#' underline='none'>
											privacy@simsouls.com
										</Link>{' '}
										to request access to, correct or delete any personal information that you have
										provided to us. We may not accommodate a request to change information if we
										believe the change would violate any law or legal requirement or cause the
										information to be incorrect.
									</Typography>
									<Typography textAlign={'justify'}>
										If you delete your User Contributions from the Website, copies of your User
										Contributions may remain viewable in cached and archived pages, or might have
										been copied or stored by other Website users. Proper access and use of
										information provided on the Website, including User Contributions, is governed
										by our terms of use{' '}
										<Link href='https://www.simsouls.com/terms' underline='none' sx={{ py: 1 }}>
											https://www.simsouls.com/terms
										</Link>
									</Typography>
								</SimSection>

								<SimSection title='V. YOUR CALIFORNIA PRIVACY RIGHTS'>
									<Typography textAlign={'justify'}>
										California Civil Code Section § 1798.83 permits users of our Website that are
										California residents to request certain information regarding our disclosure of
										personal information to third parties for their direct marketing purposes. To
										make such a request, please send an e-mail to{' '}
										<Link href='#' underline='none' sx={{ py: 1 }}>
											privacy@simsouls.com
										</Link>
										.
									</Typography>
								</SimSection>

								<SimSection title='VI. CHANGES TO OUR PRIVACY POLICY'>
									<Typography textAlign={'justify'}>
										It is our policy to post any changes we make to our Policy on this page. If we
										make material changes to how we treat our users' personal information, we will
										notify you through a notice on the Website home page. The date the Policy was
										last revised is identified at the top of the page. You are responsible for
										ensuring we have an up-to-date active and deliverable e-mail address for you,
										and for periodically visiting our Website and this Policy to check for any
										changes.
									</Typography>
								</SimSection>
								<SimSection title='VII. CONTACT INFORMATION'>
									<SimContactSupport email='privacy@simsouls.com' />
								</SimSection>
							</Stack>
						</MainCard>
					</Grid>
				</Grid>
			</StaticSectionWrapper>
		</Main>
	);
};

export default PrivacyPolicy;
